import { jsxs as v, jsx as a } from "react/jsx-runtime";
import f, { useCallback as N, useEffect as w, useContext as g } from "react";
import { MDCCheckboxFoundation as R } from "@material/checkbox";
import { useId as T, useFoundation as A, createComponent as D, mergeRefs as _, DataTableContext as E, DataTableHeadContext as y, useClassNames as P, Tag as F } from "@rmwc/base";
import { withRipple as B } from "@rmwc/ripple";
import { useToggleFoundation as H } from "@rmwc/toggleable";
const I = (t) => {
  const d = T("checkbox", t), { renderToggle: s, toggleRootProps: u, id: l } = H({ ...t, id: d }), { foundation: c, ...r } = A({
    props: t,
    elements: {
      rootEl: !0,
      checkboxEl: !0
    },
    foundation: ({ rootEl: n, checkboxEl: o, getProps: k }) => new R({
      addClass: (e) => n.addClass(e),
      removeClass: (e) => n.removeClass(e),
      setNativeControlAttr: (e, b) => o.setProp(e, b),
      removeNativeControlAttr: (e) => o.removeProp(e),
      isIndeterminate: () => !!k().indeterminate,
      isChecked: () => {
        var e;
        return k().checked !== void 0 ? !!k().checked : !!((e = o.ref) != null && e.checked);
      },
      hasNativeControl: () => !!o.ref,
      setNativeControlDisabled: (e) => o.setProp("disabled", e),
      forceLayout: () => {
        var e;
        return (e = n.ref) == null ? void 0 : e.offsetWidth;
      },
      isAttachedToDOM: () => !0
    })
  }), { rootEl: m, checkboxEl: i } = r, h = N(() => {
    i.ref && (i.ref.indeterminate = !!t.indeterminate), window.requestAnimationFrame(() => {
      c.handleChange();
    });
  }, [t.indeterminate, c, i.ref]);
  w(() => {
    h();
  }, [h]);
  const x = (n) => {
    var o;
    (o = t.onAnimationEnd) == null || o.call(t, n), c.handleAnimationEnd();
  }, C = (n) => {
    var o;
    (o = t.onChange) == null || o.call(t, n), h();
  };
  return m.setProp("onAnimationEnd", x, !0), i.setProp("onChange", C, !0), { foundation: c, renderToggle: s, toggleRootProps: u, id: l, ...r };
};
R.prototype.installPropertyChangeHooks_ = () => {
};
const G = D(
  function(d, s) {
    const { renderToggle: u, id: l, toggleRootProps: c, rootEl: r, checkboxEl: m } = I(d), {
      children: i,
      className: h,
      label: x,
      style: C,
      indeterminate: n,
      inputRef: o,
      foundationRef: k,
      ...e
    } = d, b = /* @__PURE__ */ v(
      M,
      {
        ...r.props({
          checked: e.checked,
          indeterminate: n,
          ...c
        }),
        ref: _(r.reactRef, s),
        children: [
          /* @__PURE__ */ a(
            "input",
            {
              ...m.props({
                ...e,
                className: "mdc-checkbox__native-control"
              }),
              type: "checkbox",
              ref: _(m.reactRef, o, s),
              id: l
            }
          ),
          /* @__PURE__ */ a(q, {}),
          /* @__PURE__ */ a(j, {})
        ]
      }
    );
    return u(b);
  }
), M = B({
  surface: !1,
  unbounded: !0
})(
  f.forwardRef(
    function(d, s) {
      const u = g(E), l = g(y), { disabled: c, checked: r, indeterminate: m, ...i } = d, h = P(d, [
        "mdc-checkbox",
        {
          "mdc-data-table__row-checkbox": u && !l,
          "mdc-data-table__header-row-checkbox": l,
          "mdc-checkbox--disabled": c,
          "mdc-checkbox--selected": r || m
        }
      ]);
      return /* @__PURE__ */ a(F, { ...i, className: h, ref: s });
    }
  )
), j = f.memo(function() {
  return /* @__PURE__ */ a("div", { className: "mdc-checkbox__ripple" });
}), q = f.memo(() => /* @__PURE__ */ v("div", { className: "mdc-checkbox__background", children: [
  /* @__PURE__ */ a("svg", { className: "mdc-checkbox__checkmark", viewBox: "0 0 24 24", children: /* @__PURE__ */ a(
    "path",
    {
      className: "mdc-checkbox__checkmark-path",
      fill: "none",
      stroke: "white",
      d: "M1.73,12.91 8.1,19.28 22.79,4.59"
    }
  ) }),
  /* @__PURE__ */ a("div", { className: "mdc-checkbox__mixedmark" })
] }));
export {
  G as Checkbox
};
